import { render, staticRenderFns } from "./addVipcard.vue?vue&type=template&id=bfe7c2c8&scoped=true"
import script from "./addVipcard.vue?vue&type=script&lang=js"
export * from "./addVipcard.vue?vue&type=script&lang=js"
import style0 from "./addVipcard.vue?vue&type=style&index=0&id=bfe7c2c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe7c2c8",
  null
  
)

export default component.exports